import { Pipe, PipeTransform } from '@angular/core';
import { UserType } from '../interfaces/core/core.entity';
import { LocalStorageService } from '../services/local-storage.service';

@Pipe({
	name: 'userType',
})
export class UserTypePipe implements PipeTransform {
	constructor(private ls: LocalStorageService) {}

	transform(value: string): string {
		if (!value) return '';
		const userTypes = this.ls.getTypes();
		if (!userTypes) return value;
		const userType = userTypes.find((type: UserType) => type.key === value);
		return userType ? userType.name : value;
	}
}
